import React from 'react';
import Footer from '../components/footer';
import Header from '../components/header';
import BreadCrumbsBar from '../components/breadCrumbsBar';
import Hero from '../components/hero';
import Faq from '../components/faq';
function FAQPage() {
    return (
      <div>
        <Header />
        <BreadCrumbsBar />
        <Hero />
        <Faq />
        <Footer />
      </div>
    );
  }

 export default FAQPage; 
  
  